module.exports = __webpack_public_path__ + "static/carpoolchella-cta-2-3a18768535b9bcf0b293ec22a3d3511c.jpg";